<!-- 404 -->
<template>
  <div class="error">404 NOT FOUND</div>
</template>

<script>
  export default {
    data () {
      return {

      };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {},

    methods: {}
  }
</script>
<style scoped>
  .error {
      margin: 100px auto;
      width: 300px;
      font-size: 36px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Error/Error.vue